export default "__VITE_ASSET__11a5986c__"